import React from "react";
import Style from "./PreferenceContainer.module.scss";

const PreferenceContainer = ({ children,className }) => {
  return <div className={`${Style.PreferenceContainer} ${className}`}>{children}</div>;
};

export default PreferenceContainer;
